module.exports = __webpack_public_path__ + "img/aras.d7051a9f.png";